import { annotationStateZod } from 'packages/lib/api/annotations/contract/enums';
import { z } from 'zod';
import { stateMachineMap } from 'packages/task-man/service/state-machine/constants';

export const sampleGroupParamZod = z.string();
export const objectTokenParamZod = z.string().length(32).optional(); // Per Data Services team, tokens are always 32 characters in length

export const annotationStateParamZod = z.preprocess((val) => {
  if (!val) return stateMachineMap.initial;
  return (
    Object.values(annotationStateZod.Values).find(
      (stateVal) =>
        stateVal.toLowerCase().trim() === (val as string).toLowerCase().trim()
    ) ?? stateMachineMap.initial
  );
}, annotationStateZod);

export const assigneeParamZod = z.string().email().optional();
